import { Button, Tooltip } from "antd";
import FalconCloseButton from "modules/common/FalconCloseButton";
import React, { useState } from "react";
import { InputGroup, Modal } from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import { useMarkOrderAsDelivered } from "./store";
import moment from "moment";
import { MARKING_DELIVERY_ACCESS } from "modules/utilities/utility_2";
import secureLocalStorage from "react-secure-storage";

function MarkAsDelivered({ order, buttonText }) {
  const [smShow, setSmShow] = useState(false);
  const [date, setDate] = useState(null);
  const [deliveryDate, setDeliveryDate] = useState(null);
  const [showWarning, setShowWarning] = useState();
  const { markOrderDelivered } = useMarkOrderAsDelivered();

  const handleClose = () => {
    setSmShow(false);
    setShowWarning(false);
  };
  const handleShow = () => {
    if (order.status !== "delivered") {
      setSmShow(true);
    }
  };

  const emailAccess = secureLocalStorage.getItem('email');
  
  return (
    <div>
      <Tooltip title={MARKING_DELIVERY_ACCESS.includes(emailAccess)?"Mark as Delivered":"Please contact Operations Team"}>
        <div onClick={handleShow}>
          <span
            className={`mt-n1 bg-primary ${
              (order.status === "delivered" || !MARKING_DELIVERY_ACCESS.includes(emailAccess)) && "disabled-action"
            } text-white p-2 rounded-circle d-flex justify-content-center align-items-center shadow`}
            id="markAsDelivered"
          >
            {buttonText}
          </span>
        </div>
      </Tooltip>
      <Modal
        size="m"
        show={smShow}
        onHide={handleClose}
        aria-labelledby="example-modal-sizes-title-sm"
        style={{ top: "15%" }}
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-sm">
            Mark Order As Delivered
          </Modal.Title>
          <FalconCloseButton onClick={handleClose} />
        </Modal.Header>
        <Modal.Body className="p-5">
          <InputGroup className="d-flex align-items-center justify-content-center w-100 p-0">
            <ReactDatePicker
              selected={date}
              onChange={(date) => {
                setDate(date);
                setDeliveryDate(
                  moment(date).format("YYYY-MM-DD") +
                    "T" +
                    moment().utc().format("HH:mm:ss.SSS") +
                    "Z"
                );
              }}
              className="form-control p-2"
              placeholderText="DD-MM-YYYY"
              dateFormat="dd-MMM-yyyy"
              maxDate={new Date()}
            />
            <Button
              type="primary"
              disabled={!date}
              onClick={() => setShowWarning(true)}
            >
              submit
            </Button>
          </InputGroup>
          {showWarning && (
            <div className="p-3 border border-warning rounded mt-4 mx-5">
              <p className="text-center text-warning">
                Please confirm that you want to mark this order as delivered.
                This will generate engagements schedules as per the delivery
                date selected. This process is not reversible
              </p>
              <div className="d-flex justify-content-evenly w-100 gap-5">
                <Button
                  onClick={handleClose}
                  className="flex-1"
                  disabled={order.delivery_date === ""}
                >
                  Cancel
                </Button>
                <Button
                  className="flex-1"
                  type="primary"
                  onClick={() => {
                    markOrderDelivered(order.id, deliveryDate);
                    handleClose();
                  }}
                >
                  OK
                </Button>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default MarkAsDelivered;
